// components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import sessionStore from '../stores/sessionStore' // Ваш M

const ProtectedRoute = observer(({ children }) => {
	const location = useLocation()
	const isAuthenticated = !!sessionStore?.user // Проверяем, авторизован ли пользователь
	const { isAuthChecking } = sessionStore

	// Пока идёт проверка (isAuthChecking === true) —
	// отображаем лоудер или пустую страницу.
	if (isAuthChecking) {
		return <div>Загрузка…</div>
	}

	if (!isAuthenticated) {
		const from = `${location.pathname}${location.search}${location.hash}`
		sessionStorage.setItem('reldo:returnTo', from)
		return <Navigate to='/login' replace state={{ from }} />
	}
	// Если user нет, перенаправляем на /login
	if (!sessionStore.user) {
		return <Navigate to='/login' replace />
	}

	return children // Если пользователь авторизован, отображаем дочерние компоненты
})

export default ProtectedRoute
